import {
  FILTER_BUTTON_VIEW_TYPES,
  allowsMultipleFilterButtons,
  parsePresetFilterIds,
  presetFilterParam,
  publicFilterButtons,
  togglePresetFilterIds
} from '../../../shared/filter-buttons'

function assignPresetFilterProps (instantiatedComponent, component) {

  if (!instantiatedComponent || !component || !FILTER_BUTTON_VIEW_TYPES.includes(component.type)) return

  const buttons = publicFilterButtons(component)
  const multiple = allowsMultipleFilterButtons(component)

  instantiatedComponent.filterButtonsValue = buttons
  instantiatedComponent.allowMultipleFilterButtonsValue = multiple

  const props = instantiatedComponent.props || (instantiatedComponent.props = {})

  if (!props.filterButtons) props.filterButtons = {}
  props.filterButtons.default = buttons

  if (!props.allowMultipleFilterButtons) props.allowMultipleFilterButtons = {}
  props.allowMultipleFilterButtons.default = multiple
}

const presetFilterMixin = {
  props: {
    filterButtons: { type: Array, default: () => [] },
    allowMultipleFilterButtons: { type: Boolean, default: false }
  },
  data () {
    return {
      activePresetFilterIds: []
    }
  },
  computed: {
    visiblePresetFilterButtons () {
      return publicFilterButtons({ filterButtons: this.filterButtons })
    },
    presetFiltersAllowMultiple () {
      return allowsMultipleFilterButtons({ allowMultipleFilterButtons: this.allowMultipleFilterButtons })
    },
    presetFilterQueryKey () {
      return presetFilterParam(this.componentUniqueTitle || this.uniqueTitle)
    }
  },
  mounted () {
    this.readPresetFiltersFromUrl()

    if (window.__superturbo_preview_mode) return

    if (this.activePresetFilterIds.length && typeof this.reloadForPresetFilters === 'function') {
      this.reloadForPresetFilters()
    }
  },
  methods: {
    readPresetFiltersFromUrl () {
      try {
        const params = new URLSearchParams(window.location.search)
        const known = new Set(this.visiblePresetFilterButtons.map((button) => button.id))
        const ids = parsePresetFilterIds(params.get(this.presetFilterQueryKey) || '').filter((id) => known.has(id))

        this.activePresetFilterIds = this.presetFiltersAllowMultiple ? ids : ids.slice(0, 1)
      } catch (err) {
        this.activePresetFilterIds = []
      }
    },
    writePresetFiltersToUrl () {
      try {
        const url = new URL(window.location.href)

        if (this.activePresetFilterIds.length) url.searchParams.set(this.presetFilterQueryKey, this.activePresetFilterIds.join(','))
        else url.searchParams.delete(this.presetFilterQueryKey)

        window.history.replaceState(null, '', `${url.pathname}${url.search}${url.hash}`)
      } catch (err) {
        console.warn('Failed to write filter buttons to URL:', err)
      }
    },
    presetFilterQuery () {
      return this.activePresetFilterIds.join(',')
    },
    async onPresetFilterToggle (id) {
      this.activePresetFilterIds = togglePresetFilterIds(this.activePresetFilterIds, id, this.presetFiltersAllowMultiple)
      this.writePresetFiltersToUrl()

      if (typeof this.reloadForPresetFilters === 'function') {
        await this.reloadForPresetFilters()
      }
    }
  }
}

export { assignPresetFilterProps, presetFilterMixin }
